import { ChangeEvent, useEffect, useState } from "react";
import useFirestore from "shared/hooks/useFirestore";
import useGetBranchId from "shared/hooks/useGetBranchId";

interface student{
    name:string,
    uid:string,
    state:string,
}

type AttendanceState = 'all' | 'attend' | 'tardy' | 'absent';
const useAttendanceManage = (lessonId:string) => {
    const dateFormat = (today:any):string => {
        var year = today.getFullYear();
        var month = String(today.getMonth() + 1).padStart(2, '0');
        var day = String(today.getDate()).padStart(2, '0');
        return year + '-' + month + '-' + day;
    }

    const today = new Date();
    const {getBranchId} = useGetBranchId();
    const { writeFirestore, readFirestoreOneDoc, updateFirestore} = useFirestore();
    const [attendanceCount, setAttendanceCount] = useState<{
        all: number;
        attend: number;
        tardy: number;
        absent: number;
      }>({
        all: 0,
        attend: 0,
        tardy: 0,
        absent: 0,
      });
    const [students, setStudents] = useState<student[]>([]);
    const [searchedStudents, setSearchedStudents] = useState<student[]>([]);
    const [search, setSearch] = useState("");
    const [date, setDate] = useState(dateFormat(today));
    useEffect(() => {
        if(lessonId){
            getStudentAttendanceList();
        }
        // eslint-disable-next-line
    }, [lessonId, date])

    useEffect(() => {

    }, [])


    const getStudentAttendanceList = async() => {
        setStudents([]);
        setSearchedStudents([]);
        const branch_id = await getBranchId();
        const selectedDate = date.split("-");
        const year = selectedDate[0];
        const month = (selectedDate[1][0] === "0" ? selectedDate[1][1] : selectedDate[1]);
        const day = (selectedDate[2][0] === "0" ? selectedDate[2][1] : selectedDate[2]);
        const student_uid_list = await readFirestoreOneDoc(`Assign/${branch_id}/Lesson`, lessonId).then(res => {
            if(res.exists()){
                return res.data().students;
            }
            return [];
        })
        let attend = 0;
        let tardy = 0;
        let absent = 0;
        let all = student_uid_list.length;
        for(const uid of student_uid_list){
            const student_name = await readFirestoreOneDoc("User/Auth/Student", uid).then(res => {
                if(res.exists()){
                    return res.data().name;
                }
                return "";
            })
            const attend_state = await readFirestoreOneDoc(`Attendance/${branch_id}/${year}/${month}/${day}`, uid).then(res =>{
                if(res.exists()){
                    return res.data().state;
                }
                return "";
            })

            if(attend_state === "attend"){
                attend += 1;
            }else if(attend_state === "tardy"){
                tardy += 1;
            }else if(attend_state === "absent"){
                absent += 1;
            }
            setStudents(prev => [...prev, {name:student_name, uid:uid, state:attend_state}]);
            setSearchedStudents(prev => [...prev, {name:student_name, uid:uid, state:attend_state}]);
        }
        setAttendanceCount({
            all:all,
            attend:attend,
            tardy:tardy,
            absent:absent
        })

    }

    useEffect(() => {
        const searchedItems = students.filter((item) => item["name"].includes(search));
        setSearchedStudents(searchedItems);
        // eslint-disable-next-line
    }, [search])

    const onChange = (e:ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value);
    }

    const onChangeDate = (e:ChangeEvent<HTMLInputElement>) => {
        setDate(e.target.value)
    }

    const onTodayClick = () => {
        setDate(dateFormat(today));
    }

    const incrementCount = (state: AttendanceState) => {
        setAttendanceCount((prevCount) => ({
          ...prevCount,
          [state]: prevCount[state] + 1,
        }));
      };
    
      const decresementCount = (state: AttendanceState) => {
        setAttendanceCount((prevCount) => ({
          ...prevCount,
          [state]: prevCount[state] - 1,
        }));
      };
    

    const saveAttendance = async(state:AttendanceState, student_uid:string) => {
        const branch_id = await getBranchId();
        const selectedDate = date.split("-");
        const year = selectedDate[0];
        const month = (selectedDate[1][0] === "0" ? selectedDate[1][1] : selectedDate[1]);
        const day = (selectedDate[2][0] === "0" ? selectedDate[2][1] : selectedDate[2])
        const before_attend_state = await readFirestoreOneDoc(`Attendance/${branch_id}/${year}/${month}/${day}`, student_uid).then(res => {
            if(res.exists()){
                return res.data().state;
            }
            return "";
        })
        

        if(!before_attend_state){
            await writeFirestore(`Attendance/${branch_id}/${year}/${month}/${day}`, student_uid, {state:state}).then(res => {
                if(res){
                    let students = [...searchedStudents];
                    const index = students.findIndex((item:student) => {
                        return item.uid === student_uid;
                    })
                    students[index] = {...students[index], state:state}
                    setStudents(students)
                    setSearchedStudents(students);
                    incrementCount(state)
                }
            })
        }else{
            await updateFirestore(`Attendance/${branch_id}/${year}/${month}/${day}`, student_uid, {state:state}).then(res => {
                if(res){
                    let students = [...searchedStudents];
                    const index = students.findIndex((item:student) => {
                        return item.uid === student_uid;
                    })
                    students[index] = {...students[index], state:state}
                    setStudents(students)
                    setSearchedStudents(students);
                    decresementCount(before_attend_state)
                    incrementCount(state);
                }
            })
        }
    }
    

    return {searchedStudents, search, onChange, saveAttendance, date, onChangeDate, onTodayClick, attendanceCount}
}


export default useAttendanceManage;